// LandOwnerDashboard.jsx
import { useEffect, useState } from "react";
import DashboardShell from "./DashboardShell";
import DashboardKpiRow from "./DashboardKpiRow";
import DashboardAlertList from "./DashboardAlertList";
import DashboardStatusPanel from "./DashboardStatusPanel";
import DashboardWorkflowPanel from "./DashboardWorkflowPanel";
import DashboardCard from "./DashboardCard";
import { fetchLandOwnerDashboard } from "../../api/dashboardApi";
import { LAND_OWNER_BASE_CTX } from "../../utils/presets";

export default function LandOwnerDashboard({ onOpenMap }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        fetchLandOwnerDashboard().then(setData);
    }, []);

    if (!data) {
        return (
            <DashboardShell title="Land Overview">
                <div className="text-sm text-muted-foreground">
                    Loading dashboard…
                </div>
            </DashboardShell>
        );
    }

    return (
        <DashboardShell
            title="Land Owner Overview"
            subtitle="Visibility and protection of Land Owner assets"
        >
            <div className="grid grid-cols-12 gap-6">

                {/* =========================
                    LEFT: KPIs + STATUS
                    ========================= */}
                <div className="col-span-7 space-y-6">

                    {/* KPI ROW */}
                    <div className="grid grid-cols-2 gap-4">
                        <DashboardCard
                            title="Active Operators"
                            value={data.kpis.activeOperators}
                            onClick={() =>
                                onOpenMap({
                                    ...LAND_OWNER_BASE_CTX,
                                    focus: "operators"
                                })
                            }
                        />
                        <DashboardCard
                            title="Surface Disturbance (acres)"
                            value={data.kpis.surfaceDisturbanceAcres}
                            accent="teal"
                        />
                        <DashboardCard
                            title="Producing / Idle Wells"
                            value={`${data.kpis.producingWells} / ${data.kpis.idleWells}`}
                            accent="yellow"
                        />
                        <DashboardCard
                            title="Imagery Freshness (days)"
                            value={data.kpis.imageryFreshnessDays}
                            accent={
                                data.kpis.imageryFreshnessDays > 30 ? "red" : "blue"
                            }
                        />
                    </div>

                    {/* STATUS ROW */}
                    <div className="grid grid-cols-2 gap-4">
                        <DashboardCard
                            title="Lease Coverage"
                            value={`${data.status.leaseCoveragePct}%`}
                            accent={
                                data.status.leaseCoveragePct < 90 ? "yellow" : "teal"
                            }
                        />
                        <DashboardCard
                            title="Evidence Ready"
                            value={data.status.evidenceReady ? "YES" : "NO"}
                            accent={data.status.evidenceReady ? "teal" : "red"}
                        />
                    </div>

                    {/* WORKFLOWS */}
                    <DashboardWorkflowPanel
                        actions={[
                            {
                                id: "view-land",
                                label: "View My Land",
                                onClick: () => onOpenMap(LAND_OWNER_BASE_CTX)
                            }
                        ]}
                    />
                </div>

                {/* =========================
                    RIGHT: ALERTS
                ========================= */}
                <div className="col-span-5">
                    <DashboardAlertList
                        alerts={data.alerts}
                        onOpenAlert={(alert) =>
                            onOpenMap(alert.mapContext)
                        }
                    />
                </div>

            </div>
        </DashboardShell>
    );
}